import * as React from "react";
import PropTypes from "prop-types";
import { iconsDb } from "../../assets/iconsDB.gen";
import HarveyBall from "../../assets/icons/harvey/HarveyBall";
import { LazyIcon } from "../common/LazyIcon";
import { getIconSize } from "../../helpers/iconUtils";

const getIconEnclosureStyle = (iconEnclosure, iconColor, iconSize) => {
  if (!iconEnclosure || iconEnclosure === "none") {
    return {};
  }

  const color = iconColor || "#000000";
  const style = {
    padding: Math.max(getIconSize(iconSize) * 0.1 + 4, 4),
    borderRadius: "50%",
    border: iconEnclosure ? `2px solid ${color}` : "none",
    backgroundColor: iconEnclosure === "filled" ? color : "transparent",
  };

  return style;
};

const getIconColor = (iconEnclosure, iconColor) => {
  if (iconEnclosure === "filled") {
    const color = iconColor?.toLowerCase();
    if (color === "#ffffff" || color === "white" || color === "#fff") {
      return "#000000";
    }
    return "#FFFFFF";
  }

  return iconColor ?? "#000000";
};

const CellIcon = (props) => {
  const { id, iconSize, iconColor, iconAlign, iconEnclosure, iconStyle } = props;
  const icon = iconsDb.find((i) => i.id === id);
  const size = getIconSize(iconSize);
  const width = size;
  const height = size;

  const marginLeft = iconStyle?.marginLeft ?? iconStyle?.margin ?? 0;
  const marginRight = iconStyle?.marginRight ?? iconStyle?.margin ?? 0;
  const marginLeftPerc = iconStyle?.marginLeftPerc ?? iconStyle?.marginPerc ?? 0;
  const marginRightPerc = iconStyle?.marginRightPerc ?? iconStyle?.marginPerc ?? 0;
  const ml = `calc(${iconAlign === "center" ? 50 - marginRightPerc + marginLeftPerc : marginLeftPerc}% ${iconAlign === "center" ? "- " + width / 2 + "px" : ""} ${iconAlign === "center" ? "+ " + (marginLeft - marginRight) : "+ " + marginLeft}px)`;
  const mr = `calc(${iconAlign === "center" ? 50 - marginLeftPerc + marginRightPerc : marginRightPerc}% ${iconAlign === "center" ? "- " + width / 2 + "px" : ""} ${iconAlign === "center" ? "+ " + (marginRight - marginLeft) : "+ " + marginRight}px)`;
  //const width = `calc(${size}px + ${marginLeft + marginRight}px + ${marginLeftPerc + marginRightPerc}%)`;

  const marginTop = iconStyle?.marginTop ?? iconStyle?.margin ?? 0;
  const marginTopPerc = iconStyle?.marginTopPerc ?? iconStyle?.marginPerc ?? 0;
  const mt = `calc(${marginTopPerc}% + ${marginTop}px)`;
  const marginBottom = iconStyle?.marginBottom ?? iconStyle?.margin ?? 0;
  const marginBottomPerc = iconStyle?.marginBottomPerc ?? iconStyle?.marginPerc ?? 0;
  const mb = `calc(${marginBottomPerc}% + ${marginBottom}px)`;
  //const height = `calc(${size}px + ${marginTop + marginBottom}px + ${marginTopPerc + marginBottomPerc}%)`;

  //console.log("Cell icon margin calcs", { iconStyle, width, height, ml, mr, mt, mb });

  return (
    <div
      style={{
        alignSelf: iconAlign === "center" ? "end" : "center",
        justifySelf: iconAlign ?? "center",
        width,
        height,
        marginLeft: ml,
        marginTop: mt,
        marginRight: mr,
        marginBottom: mb,
        ...getIconEnclosureStyle(iconEnclosure, iconColor, iconSize),
        zIndex: iconStyle?.zIndex,
      }}
    >
      {icon?.type === "harvey" ? (
        <HarveyBall
          type={icon.icon}
          size={size}
          color={getIconColor(iconEnclosure, iconColor)}
          color2={iconEnclosure === "filled" ? iconColor : undefined}
        />
      ) : (
        <LazyIcon
          id={id}
          name={icon.name}
          source={icon.source}
          color={getIconColor(iconEnclosure, iconColor)}
          size={size}
        />
      )}
    </div>
  );
};

CellIcon.propTypes = {
  type: PropTypes.string,
  id: PropTypes.string,
  iconColor: PropTypes.string,
  iconSize: PropTypes.any,
  iconAlign: PropTypes.string,
  iconEnclosure: PropTypes.string,
  iconStyle: PropTypes.object,
};

export default CellIcon;
